import { Divider } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import {
  Badge,
  Box,
  Button,
  FormControlLabel,
  Grid,
  InputLabel,
  Paper,
  Stack,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";

import "@fontsource/manrope";
import { getBrandCustom } from "../../../../../../../util/getCustomColor";

export const StyledRadioBox = styled(Box, { shouldForwardProp: (prop) => prop !== "isSelected" })<{
  isSelected?: boolean;
}>(({ theme, isSelected }) => ({
  border: `2px solid ${isSelected ? "#004D95" : "#E4E7EC"}`,
  padding: theme.spacing(1),
  display: "flex",
  flexDirection: "column",
  borderRadius: "12px",
  transition: "border-color 0.3s",
  marginTop: "10px",
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  width: "100%",
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(0),
  fontFamily: "Manrope !important",
  fontSize: "14px  !important",
  fontStyle: "normal  !important",
  color: "#475467  !important",
}));

export const StyledGridContainer = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(2),
  '& [class^="makeStyles-label"]': {
    color: "#004D95 !important",
  },
}));

export const StyledGridItem = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(1),
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const StyledInputLabel = styled(InputLabel)(() => ({
  color: "#004D95",
}));

export const CircleBadge = styled(Badge)(({ theme }) => ({
  ".MuiBadge-dot": {
    borderRadius: "50%",
    width: 24,
    height: 24,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export const StyledFormControlLabel = styled(FormControlLabel, {
  shouldForwardProp: (prop) => prop !== "isSelected",
})<{ isSelected?: boolean }>(({ isSelected }) => ({
  "& .MuiFormControlLabel-label": {
    color: isSelected ? "#004D95" : "#000",
    transition: "color 0.3s",
    fontfamily: "monrope",
    fontWeight: 400,
    fontSize: "20px",
    lineHeight: "22px",
  },
}));

const styles = makeStyles(() => ({
  equipment_input: {
    backgroundColor: "red",
  },
  ordersTab: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "100%",
    overflowX: "hidden",
    overflowY: "hidden",
    padding: "24px 32px 24px 32px",
  },
  uiTab: {
    minHeight: "calc(100vh - 310px) !important",
    height: "100% !important",
  },
  headerBreadcrumbs: {
    "& ol": {
      alignItems: "flex-end",
    },
  },
  headerBreadcrumbsTitle: {
    fontSize: 18,
    lineHeight: "24px",
    fontWeight: "bold",
    color: getBrandCustom("primaryColor", "#38cfc4"),
    fontFamily: `'Manrope', sans-serif`,
    "&.active": {
      color: "#465869",
    },
  },
  Wrapper: {
    // padding: "24px 24px 0 24px",
  },
}));

export default styles;

export const StyledBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(2),
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: theme.shape.borderRadius,
  marginBottom: theme.spacing(2),
}));
export const RemoveEditToggleButton = styled(ToggleButton)(({ theme }) => ({
  fontFamily: "Manrope",
  fontSize: "10px !important",
  textTransform: "none",
  height: "30px",
  width: "100%",
  fontStyle: "normal",
  fontWeight: 700,
  color: theme.palette.mode === "dark" ? "#FFFFFF" : "#475467",
  backgroundColor: "transparent",
  border: "none",
  borderRadius: "4px",
  transition: "all 0.1s ease",
  textAlign: "center",
  whiteSpace: "nowrap",
  overflow: "hidden",
  "&:hover": {
    backgroundColor: "transparent",
    color: "#0055A4",
  },
  "&.Mui-selected": {
    color: "#FFFFFF",
    backgroundColor: "#0055A4",
    borderRadius: "8px",
    border: "none",
  },
}));

export const ModalGridContainer = styled(Box)(({ theme }) => ({
  backgroundColor: "#ffffff !important",
  position: "absolute",
  padding: "24px",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  height: "80%",
  overflowY: "scroll",
  borderRadius: "12px",
  boxShadow: theme.shadows[24],
  p: theme.spacing(4),
}));
export const TeamsModalContainer = styled(Box)(({ theme }) => ({
  position: "absolute",
  backgroundColor: "#ffffff !important",
  padding: theme.spacing(3),
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  height: "80%",
  overflowY: "scroll",

  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[24],
}));
export const ModalTitle = styled("div")(() => ({
  color: "var(--Neutral-Gray-600, #475467)",
  fontFamily: "Manrope !important",
  fontSize: "22px !important",
  fontStyle: "normal !important",
  fontWeight: "700 !important",
  lineHeight: "28px !important",
}));

export const ModalTypography = styled(Typography)(() => ({
  fontSize: "16px",
  fontFamily: "Manrope !important",
  fontWeight: 400,
  color: "var(--Neutral-Gray-600, #475467)",
  lineHeight: "24px",
  margin: 0,
}));

export const ModalContainer = styled(Box)(({ theme }) => ({
  // sx={{ backgroundColor: "#ffffff", padding: "2rem", width: "30%" }}
  boxSizing: "border-box",
  position: "absolute",
  padding: "2rem !important",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30% !important",
  borderRadius: "20px",
  backgroundColor: "#ffffff !important",
  boxShadow: theme.shadows[24],
}));

export const ModalHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  marginBottom: theme.spacing(1),
  justifyContent: "space-between",
}));

export const ModalContent = styled(Box)(({ theme }) => ({
  display: "flex",
  padding: theme.spacing(3),
  margin: theme.spacing(1),
  marginBottom: theme.spacing(1),
  flexDirection: "column",
  justifyContent: "space-around !important",
  backgroundColor: "#F9FAFB !important",
  borderRadius: "8px !important",
}));

export const DateRangeContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
  justifyContent: "space-between",
  alignItems: "center",
}));

export const ActionButtonContainer = styled(Box)(({ theme }) => ({
  borderRadius: "4px",
  bgcolor: "white",
  width: "100%",
  marginTop: theme.spacing(2),
  display: "flex",
  justifyContent: "flex-end",
}));

export const FullWidthContainer = styled(Box)(() => ({
  width: "100%",
  height: "100%",
  paddingTop: "2rem",
  paddingBottom: "1rem",
}));

export const ToggleContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

export const NoDataCenteredBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(10.5),
  marginBottom: theme.spacing(10.5),
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
}));

export const NoDataImagebox = styled("img")(() => ({
  maxWidth: "100%",
  height: "auto",
}));

export const AddButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#0055A4 !important",
  "&.MuiButton-root": {
    textTransform: "none !important",
  },
  marginTop: theme.spacing(5),
  color: "#ffffff",
}));

export const ActionButtonsBox = styled(Box)(({ theme }) => ({
  borderRadius: "4px",
  backgroundColor: "white",
  width: "100%",
  marginTop: theme.spacing(2),
  display: "flex",
  justifyContent: "flex-end",
  padding: theme.spacing(1),
}));

export const CancelButton = styled(Button)(() => ({
  color: "#000000 !important",
  "&.MuiButton-root": {
    textTransform: "none !important",
  },
}));

export const CreateButton = styled(Button)(() => ({
  backgroundColor: "#12B76A !important",
  color: "#ffffff !important",
  "&.MuiButton-root": {
    textTransform: "none !important",
  },
}));

export const ButtonStack = styled(Stack)(() => ({
  spacing: 2,
  height: "35px",
  flexDirection: "row",
}));
export const UiTabContainer = styled(Box)(() => ({
  width: "100%",
  height: "100%",
  padding: "2% 2%",
  backgroundColor: "#F9FAFB",
}));
export const TabDivider = styled(Divider)(() => ({
  marginY: "20px !important",
}));

export const MemberInfoContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  alignContent: "center",
  textAlign: "center",
}));

export const MemberContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
}));
export const MembersButtonContainer = styled(Box)(({ theme }) => ({
  borderRadius: "4px",
  bgcolor: theme.palette.background.paper,
  width: "100%",
  marginTop: theme.spacing(2),
  display: "flex",
  justifyContent: "flex-end",
}));

export const TabDividerContainer = styled(Divider)(({ theme }) => ({
  marginY: theme.spacing(2),
}));

export const CustomToggleButtonGroup = styled(ToggleButtonGroup)(() => ({
  height: "40px",
  borderRadius: "10px",
  textTransform: "none",
  "& .MuiToggleButton-root": {
    borderRadius: "10px",
  },
  "& .Mui-selected": {
    borderRadius: "10px",
  },
}));

export const CustomToggleButton = styled(ToggleButton)(() => ({
  textTransform: "none",
}));
export const UnavailabilityContent = styled(Box)(() => ({
  padding: "10px 5px",
}));
